import type {Observable} from 'rxjs';
import type {Exemplar, ExemplarType, ViewableExemplar} from 'typings/portaro.be.types';
import type {ObservableAjaxService} from 'core/data-services/observable-ajax.service';
import {transferify} from 'shared/utils/data-service-utils';

export interface ExemplarQuery {
    q?: string;
    document?: number;
    allowedExemplarTypes?: ExemplarType[];
    viewable?: boolean;
    user?: number;
    pageNumber?: number;
    pageSize?: number;
}

/**
 * @ngdoc service
 * @name observableExemplarDataService
 * @module portaro.data-services
 *
 * @description
 * Service for `Exemplar` handling
 *
 * @requires service:observableAjaxService
 */
export default class ObservableExemplarDataService {
    public static serviceName = 'observableExemplarDataService';

    public static readonly ROUTE = 'exemplars';

    /*@ngInject*/
    constructor(private observableAjaxService: ObservableAjaxService) {
    }

    /**
     * @ngdoc method
     * @name observableExemplarDataService#getExemplars
     *
     * @param {ExemplarQuery} query Query object
     * @returns {Observable<ViewableExemplar[]>}
     *
     * @description
     * Return found exemplars stream
     */
    public getExemplars(query: ExemplarQuery): Observable<ViewableExemplar[]> {
        return this.observableAjaxService
                   .forUri(ObservableExemplarDataService.ROUTE)
                   .get<ViewableExemplar[]>(query);
    }

    /**
     * @ngdoc method
     * @name observableExemplarDataService#getViewableExemplars
     *
     * @param {Exemplar[]} exemplars list of exemplars to be extended to viewable
     * @returns {Observable<ViewableExemplar[]>}
     *
     * @description
     * Return exemplars that were extended to viewable exemplars
     */
    public getViewableExemplars(exemplars: Exemplar[]): Observable<ViewableExemplar[]> {
        return this.observableAjaxService
            .forUri(ObservableExemplarDataService.ROUTE)
            .get<ViewableExemplar[]>({id: transferify(exemplars), viewable: true});
    }

}
